
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ProcessorOnboardingListItem.scss';

export default class ProcessorOnboardingListItem extends Component {
    static propTypes = {
        item: PropTypes.any
    };

    renderMerchantName(merchantName) {
        return merchantName ? merchantName : 'No Merchant Name';
    }

    renderApplicationStatus(status) {
        return status ? status : 'No Status';
    }

    render() {
        const application = this.props.item;

        return (
            <div className="processor-onboarding-list-item">
                <div className="processor-onboarding-list-item-left">
                    <span className="processor-onboarding-merchantName">
                        {this.renderMerchantName(application.merchantName)}
                    </span>
                    <span className="processor-onboarding-merchantId">
                        {application.merchantId}
                    </span>
                </div>
                <div className="processor-onboarding-list-item-right">
                    <span className="processor-onboarding-status">
                        {this.renderApplicationStatus(application.status)}
                    </span>
                </div>
            </div>
        );
    }
}
